export default __webpack_public_path__ + "static/media/card-blog4.6c9db5e6.jpg";